// A video's recommendations strip: the videos a player offers when it ends, and their heading.

import { api } from '../client'
import type { components } from '../schema'

export type AssetRecommendationsView = components['schemas']['AssetRecommendationsView']
export type AssetRecommendationEntry = components['schemas']['AssetRecommendationEntry']
export type UpdateAssetRecommendationsRequest = components['schemas']['UpdateAssetRecommendationsRequest']

function recommendationsPath(assetId: string): string {
  return `/assets/${encodeURIComponent(assetId)}/recommendations`
}

/**
 * A video's strip, every listed video whatever its state; an empty list and a `null` heading for
 * one that has none.
 */
export function getAssetRecommendations(assetId: string, signal?: AbortSignal): Promise<AssetRecommendationsView> {
  return api.get<AssetRecommendationsView>(recommendationsPath(assetId), undefined, signal)
}

/**
 * Replace a video's strip whole: at most eight videos, in order. A video still listed keeps its
 * place in the database and one left out is unlinked; an empty list removes the strip. 409 when a
 * listed video already recommends this one.
 */
export function setAssetRecommendations(
  assetId: string,
  request: UpdateAssetRecommendationsRequest,
): Promise<AssetRecommendationsView> {
  return api.put<AssetRecommendationsView>(recommendationsPath(assetId), request)
}
